import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Extract authorization code from query params
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    const redirectUri = window.location.origin + '/auth/callback';

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/callback`, {
          code,
          redirect_uri: redirectUri
        });
        if (data.access_token) {
          localStorage.setItem('access_token', data.access_token);
        }
        // If new user or needs profile completion, redirect to complete-profile
        if (data.needs_profile_completion) {
          window.location.replace('/complete-profile');
        } else {
          window.location.replace('/home');
        }
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true, state: { error: 'Google sign-in failed. Please try again.' } });
      }
    })();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-[#070A1A] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#D4AF37]/30 border-t-[#D4AF37] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#BDB2C4] font-['Playfair_Display']">Completing sign in...</p>
      </div>
    </div>
  );
}
